import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const FixedBanner = styled.div`
  position: sticky;
  z-index: 1;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 120px;
  background: white;
  box-shadow: 0px -14px 14px rgba(0, 0, 0, 0.15);
  align-items: center;
  justify-content: center;
  display: none;

  ${mediaQuery('phone')} {
    height: 80px;
  }
`;
